import viewCollections from "./viewCollections"
export default viewCollections;
